import React, { useEffect } from 'react';
import { NavLink, useSearchParams } from 'react-router-dom';
import { Breadcrumb, Pagination, Spin } from 'antd';
import { useArticlesGet } from '../../../hooks/api/article';
import SearchCard from '../SearchResults/Card';

import styles from './index.module.scss';
import NoData from '../../Common/NoData';

export default function BookmarksContent(): React.ReactNode | null {
  const articlesGet = useArticlesGet({ autoStart: false });
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number.parseInt(searchParams.get('page') ?? '1', 10);

  const { data: responseData, loading, fetch } = articlesGet;
  const meta = responseData?.meta;
  const articles = responseData?.data;

  const refetch = () => {
    fetch({
      pageSize: '10',
      page: page.toString(),
      status: 'published',
      bookmarked: true,
    });
  };

  useEffect(() => {
    refetch();
  }, [page]);

  useEffect(() => {
    if (!loading && articles?.length === 0 && page > 1) {
      setSearchParams((prev) => {
        const params = new URLSearchParams(prev);

        params.set('page', (page - 1).toString());

        return params;
      });
    }
  }, [articles, loading, page]);

  const onChange = (newPage: number) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);

      params.set('page', newPage.toString());

      return params;
    });
  };

  return (
    <div className="wrapper">
      <div className={styles.content}>
        <div className={styles.breadcrumb}>
          <Breadcrumb
            items={[
              {
                title: <NavLink to="/" className={styles.breadcrumbLink}>Help portal</NavLink>,
              },
              {
                title: 'Bookmarks',
              },
            ]}
          />
        </div>
        <h2>Bookmarks</h2>

        {articles?.length
          ? articles.map((item) => (
            <div key={item.id}>
              <SearchCard data={item} refetch={refetch} />
            </div>
          ))
          : !loading && <NoData />}

        {meta && (
          <div className="customPagination">
            <div style={{ textAlign: 'center' }}>
              <Pagination
                showSizeChanger={false}
                total={meta.itemCount}
                pageSize={meta.pageSize}
                current={page}
                onChange={onChange}
              />
              <div style={{ marginTop: 8, color: '#1F3847AD' }}>
                {(page - 1) * meta.pageSize + 1}
                –
                {Math.min(page * meta.pageSize, meta.itemCount)}
                {' '}
                of
                {' '}
                {meta.itemCount}
                {' '}
                results
              </div>
            </div>
          </div>
        )}
      </div>
      {loading && (
        <div className="spin">
          <Spin />
        </div>
      )}
    </div>
  );
}
